import React from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Image } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { MdVisibility } from 'react-icons/md';
import { MdOutlineDateRange } from 'react-icons/md';
import { FcShare } from 'react-icons/fc';
import { FaTelegramPlane, FaFacebookF } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import "swiper/css";
import "swiper/css/pagination";

import { motion } from "framer-motion"
import "swiper/css/navigation";
import "./assets/OpenNews.css";
import { useCookies } from 'react-cookie';
import { FacebookShareButton, TelegramShareButton } from 'react-share';
import { api } from '../host/Host';
import axios from 'axios';
import { isNumericId, sanitizeHtml } from '../utils/security';

function OpenNews() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState({})
    const [error, setError] = useState(false)
    const [newsUz, setnewsUz] = useState([])

    const [, setCookie] = useCookies([]);
    const params = useParams();
    const { id } = params;
    const [seenCookies] = useCookies([`${id}`])

    const getOpenNews = useCallback((newsId) => {
        if (!isNumericId(newsId)) {
            setError(true);
            return;
        }

        setCookie(newsId, newsId, {
            maxAge: 300
        });

        axios.get(`${api}/GetApi/GetNewsById/?id=${newsId}&seen=${Object.prototype.hasOwnProperty.call(seenCookies, `${newsId}`)}`)
            .then((res) => {
                const config = res.data;
                if (!config || !config.id) {
                    setError(true);
                    return;
                }

                const textUz = config.mainTextUz;
                const textRu = config.mainTextRu;
                const date = config.newsDate.substring(0, 10);
                const formattedDate = `${date.substring(8, 10)}.${date.substring(5, 7)}.${date.substring(0, 4)}`;
                config.newsDate = formattedDate;

                let updatedUz = "";
                let updatedRu = "";

                if (textUz !== null) {
                    textUz.split("</p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>").forEach((item) => {
                        updatedUz += item + "<br/><br/>";
                    });

                    let normalizedUz = "";
                    updatedUz.split("</p>\r\n\r\n<p>").forEach((item) => {
                        normalizedUz += item + "<br/>";
                    });
                    config.mainTextUz = sanitizeHtml(normalizedUz);
                }

                if (textRu !== null) {
                    textRu.split("</p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>").forEach((item) => {
                        updatedRu += item + "<br/><br/>";
                    });

                    let normalizedRu = "";
                    updatedRu.split("</p>\r\n\r\n<p>").forEach((item) => {
                        normalizedRu += item + "<br/>";
                    });
                    config.mainTextRu = sanitizeHtml(normalizedRu);
                }

                config.mainTextEn = sanitizeHtml(config.mainTextEn);
                config.mainTextKrill = sanitizeHtml(config.mainTextKrill);

                setData(config);
            })
            .catch(() => setError(true))

        axios.get(`${api}/GetApi/GetNews/`)
            .then((res) => {
                const formattedNews = [];

                res.data.forEach((item) => {
                    const newsItem = { ...item };
                    newsItem.newsDate = `${newsItem.newsDate.substring(8, 10)}.${newsItem.newsDate.substring(5, 7)}.${newsItem.newsDate.substring(0, 4)}`;
                    if (newsItem.titleUz !== null) {
                        formattedNews.push(newsItem);
                    }
                });

                setnewsUz(formattedNews.slice(0, 6))
            }).catch(() => {})
    }, [seenCookies, setCookie])

    useEffect(() => {
        if (!isNumericId(id)) {
            setError(true);
            navigate("/error", { replace: true });
            return;
        }

        getOpenNews(id)
    }, [id, navigate, getOpenNews]);

    const articleHtml = useMemo(() => sanitizeHtml(data[`mainText${t('lang')}`]), [data, t]);

    return (
        <motion.div initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}  transition={{ duration: 1.1 }} className="open-news" style={{padding:'50px 18%'}}>
            {
            error?<Navigate to="/error" />:
            <div className="container" >
                <Row >
<Col lg={17} md={24} sm={24}>

<div className="open-news-title">
                    {Object.keys(data).length !== 0 &&
                      <h5>{data[`title${t('lang')}`]}</h5>
                    }
                </div>
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div className="open-news-visites">
                        <div>
                            <p><FcShare className='icon' size='1.4rem' /></p>
                            <p className="yoz"></p>
                        </div>
                        <FacebookShareButton
                            url={`${api}/allnews/${data.id}`}
                            quote={t('lang') === 'uz' ? data.titleUz : data.titleRu}
                            hashtag={"#vatanparvar"}
                            className="Demo__some-network__share-button"
                        >
                            <div className="date">
                                <p><FaFacebookF className='icon' size='1.4rem' /></p>
                                <p className="yoz"></p>
                            </div>
                        </FacebookShareButton>
                        <TelegramShareButton
                            url={`${api}/allnews/${data.id}`}
                            title={data[`title${t('lang')}`]}
                            className="Demo__some-network__share-button"
                        >
                            <div className="date">
                                <p><FaTelegramPlane className='icon' size='1.4rem' /></p>
                                <p className="yoz"></p>
                            </div>
                        </TelegramShareButton>
                    </div>
                    <div className="open-news-visites">
                        <div className="date">
                            <p><MdOutlineDateRange className='icon' size='1.4rem' /></p>
                            {Object.keys(data).length !== 0 &&
                                <p>{data.newsDate.substring(0, 10)}</p>
                            }
                        </div>
                        <div className="visites">
                            <p><MdVisibility className='icon' size='1.4rem' /></p>
                            {Object.keys(data).length !== 0 &&
                                <p>{data.visits}</p>
                            }
                        </div>
                    </div>
                </div>
                <Image.PreviewGroup>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={30}
                      autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                      }}
                      loop={true}
                      navigation={true}
                      className="mySwiper"
                    >
                      <SwiperSlide>
                          <div
                            className="swiper-slide_body"
                            style={{
                              display:'flex',
                              alignItems:'center',
                              justifyContent:'center',
                           }}
                          >
                            <img
                              className='red'
                              style={{height:'auto', width:"100%" }}
                              src={`${api}/Files/News/${data.titleImage}`}
                              alt={data[`title${t('lang')}`] || 'News cover'}
                            />
                          </div>
                      </SwiperSlide>

                      {data.newsImage && data.newsImage.length!==0 ? data.newsImage.map((item, index)=>{
                          return(
                            <SwiperSlide key={item.id || index}>
                              <div
                                className="swiper-slide_body"
                                style={{
                                    display:'flex',
                                    alignItems:'center',
                                    justifyContent:'center',
                                }}
                              >
                                <img
                                  className='red'
                                  style={{height:'auto', width:"100%"}}
                                  src={`${api}/Files/News/${item.imageUrl}`}
                                  alt={data[`title${t('lang')}`] || 'News image'}
                                />
                              </div>
                            </SwiperSlide>
                          )
                      }):''}
                    </Swiper>

                    <div className="open-news-text">
                        {Object.keys(data).length !== 0 &&
                            <div className='salomText' style={{textAlign:'justify', lineHeight:"2", fontSize:'18px', textIndent:'50px'}} dangerouslySetInnerHTML={{__html: articleHtml}} />
                        }
                    </div>
                </Image.PreviewGroup>
    </Col>
    <Col lg={7} md={0} sm={0} className="newTabCol">
   <ul className="newTab">
       <h4>{t("So'ngi yangiliklar")}</h4>

       {newsUz!==null?newsUz.map((item, key)=>{
           return(
            <li key={item.id || key} onClick={()=>{getOpenNews(item.id)}}>
              <Link to={"/allnews/" + item.id} className="news_list-item1">
                <div className='icons'>
                  <p className='tabDate'><MdOutlineDateRange className='icon' size='1rem' />{
                    item.newsDate.substring(0, 10)
                  }</p>
                  <p className='tabDate'>{
                    item.visits
                  }<MdVisibility className='icon' size='1rem' /></p>
                </div>
                <div className='titles'>
                  <p className='tabTitle' style={{textTransform:'uppercase'}}>{item[`title${t('lang')}`]}</p>
                </div>
              </Link>
            </li>)
       }):<></>}
   </ul>
        </Col>

                </Row>

<br/>
<br/>

            </div>}

        </motion.div>
    )
}

export default OpenNews;
